class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.updateMenuPosition = () => {
      if (this.positionFrame) return;
      this.positionFrame = requestAnimationFrame(() => {
        this.positionFrame = null;
        if (!this.mainDetailsToggle.open || !this.header) return;
        document.documentElement.style.setProperty(
          '--header-bottom-position-desktop',
          `${Math.max(0, Math.ceil(this.header.getBoundingClientRect().bottom))}px`
        );
      });
    };
    this.mainDetailsToggle.querySelector('summary').addEventListener('click', (event) => {
      // Hover has already opened the menu before a mouse click reaches the arrow.
      // Do not let that click immediately close it; touch and keyboard still toggle.
      if (event.pointerType === 'mouse' && window.matchMedia('(min-width: 1200px)').matches && this.mainDetailsToggle.open) {
        event.preventDefault();
      }
    }, true);
    this.addEventListener('pointerenter', (event) => {
      if (event.pointerType !== 'mouse' || !window.matchMedia('(min-width: 1200px)').matches) return;
      this.closest('.header__inline-menu')?.querySelectorAll('header-menu').forEach((menu) => {
        if (menu !== this) menu.close();
      });
      this.mainDetailsToggle.open = true;
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
    });
    this.addEventListener('pointerleave', (event) => {
      // Progressive navigation owns its delayed, focus-aware close handling.
      if (this.querySelector('[data-dhs-progressive-menu]')) return;
      if (event.pointerType === 'mouse' && window.matchMedia('(min-width: 1200px)').matches) this.close();
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = !!this.header.querySelector('header-menu details[open]');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', this.mainDetailsToggle.open);
    if (this.mainDetailsToggle.open) {
      // Recalculate against the viewport, including after sticky-header movement.
      this.updateMenuPosition();
      window.addEventListener('scroll', this.updateMenuPosition, { passive: true });
      window.addEventListener('resize', this.updateMenuPosition);
      this.header.closest('.section-header')?.addEventListener('transitionend', this.updateMenuPosition);
    } else {
      this.stopPositionUpdates();
    }
  }

  stopPositionUpdates() {
    window.removeEventListener('scroll', this.updateMenuPosition);
    window.removeEventListener('resize', this.updateMenuPosition);
    this.header?.closest('.section-header')?.removeEventListener('transitionend', this.updateMenuPosition);
    cancelAnimationFrame(this.positionFrame);
    this.positionFrame = null;
  }

  disconnectedCallback() {
    this.stopPositionUpdates();
  }
}

customElements.define('header-menu', HeaderMenu);
